/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Outcome of probing the provider with the stored credentials.
 */
export type DeviceIntegrationTestConnectionResult = {
  /**
   * Human-readable failure detail. Omitted on success.
   */
  message?: string | undefined;
  /**
   * Whether the provider accepted the stored credentials.
   */
  ok: boolean;
};

/** @internal */
export const DeviceIntegrationTestConnectionResult$inboundSchema: z.ZodMiniType<
  DeviceIntegrationTestConnectionResult,
  unknown
> = z.object({
  message: z.optional(z.string()),
  ok: z.boolean(),
});

export function deviceIntegrationTestConnectionResultFromJSON(
  jsonString: string,
): SafeParseResult<DeviceIntegrationTestConnectionResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      DeviceIntegrationTestConnectionResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'DeviceIntegrationTestConnectionResult' from JSON`,
  );
}
